import React from 'react';
import { Phone } from 'lucide-react';
import { Link } from 'react-router-dom';

const PRINCIPAL = [
  { to: '/', label: '🏠 Accueil', testId: 'nav-home-link' },
  { to: '/rendez-vous', label: '📅 Prendre rendez-vous', testId: 'nav-rdv-link' },
  { to: '/zones-intervention', label: "📍 Zones d'intervention (Loire 42)", testId: 'nav-zones-link' },
  { to: '/blog', label: '📝 Blog & conseils', testId: 'nav-blog-link' },
];

const SERVICES = [
  { to: '/reparation-iphone-saint-chamond', label: '📱 Réparation iPhone Saint-Chamond' },
  { to: '/reparation-samsung-saint-chamond', label: '📱 Réparation Samsung Saint-Chamond' },
  { to: '/changement-ecran-iphone-saint-chamond', label: '🖥️ Changement écran iPhone' },
  { to: '/remplacement-batterie-iphone-saint-chamond', label: '🔋 Remplacement batterie iPhone' },
  { to: '/reparation-telephone-saint-etienne', label: '📍 Réparation téléphone Saint-Étienne' },
  { to: '/reparation-connecteur-charge-saint-chamond', label: '🔌 Réparation connecteur de charge' },
  { to: '/reparation-degats-eaux-saint-chamond', label: '💧 Réparation dégâts des eaux' },
];

const WhatsAppIcon = () => (
  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
  </svg>
);

const MenuColumn = ({ titre, liens, onClick, strong }) => (
  <div className="space-y-2">
    <p className="text-xs font-bold text-gray-500 uppercase px-4 mb-3">{titre}</p>
    {liens.map((l) => (
      <Link
        key={l.to}
        to={l.to}
        onClick={onClick}
        data-testid={l.testId}
        className={`block py-3 px-4 rounded-lg transition-colors hover:bg-blue-50 ${strong ? 'text-gray-900 font-medium text-lg' : 'text-gray-700'}`}
      >
        {l.label}
      </Link>
    ))}
  </div>
);

/** Contenu du menu déroulant (2 colonnes sur PC, 1 sur mobile) + boutons d'action. */
const NavigationMenu = ({ onClose }) => (
  <div className="bg-white border-t border-gray-200 shadow-xl" data-testid="nav-menu">
    <div className="max-w-7xl mx-auto px-4 py-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <MenuColumn titre="Navigation" liens={PRINCIPAL} onClick={onClose} strong />
        <MenuColumn titre="Nos Services" liens={SERVICES} onClick={onClose} />
      </div>

      <div className="mt-6 pt-6 border-t border-gray-200">
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a href="tel:0773601521" className="flex items-center justify-center gap-2 bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-lg font-bold text-lg shadow-lg transition-all">
            <Phone className="w-6 h-6" />
            <span>Appeler : 07.73.60.15.21</span>
          </a>
          <a href="https://wa.me/33773601521" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#20BD5A] text-white px-8 py-4 rounded-lg font-bold text-lg shadow-lg transition-all">
            <WhatsAppIcon />
            <span>WhatsApp</span>
          </a>
          <Link to="/rendez-vous" onClick={onClose} className="flex items-center justify-center gap-2 bg-blue-500 hover:bg-blue-600 text-white px-8 py-4 rounded-lg font-bold text-lg shadow-lg transition-all">
            📅 <span>Prendre rendez-vous</span>
          </Link>
        </div>
      </div>
    </div>
  </div>
);

export default NavigationMenu;
